import { string, shape } from 'prop-types';

export default shape({
  id: string,
  label: string,
  href: string,
});
